module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-4-subhead"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    staticClass: "C_Current__And__Bodoni_MT__And__Bold__And__No_Italic"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008"
    }
  }, [_vm._v("Part 1 Setting the Scene")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/section0009"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/section0009"
    }
  }, [_vm._v("Dallas: City of Hate")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-9"
  }, [_c('a', {
    attrs: {
      "href": "#/section0010"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/section0010"
    }
  }, [_vm._v("Johnny, We Hardly Knew Ye, or John Kennedy, Cold Warrior")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Eerie and Terrifying Cultural Climate")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Politics of Charisma")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    staticClass: "C_Current__And__Bodoni_MT__And__Bold__And__No_Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2 Seeing Is Believing")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 22-25, 1963: Images of Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Witnesses")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dallas: The Eyes of the Liberal Media Are Upon You")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dallas: November 25, 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    staticClass: "C_Current__And__Bodoni_MT__And__Bold__And__No_Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3 The Seventies: A Time of Cultural Redemption")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack Ruby: All-American Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('span', {
    staticClass: "C_Current__And__Bodoni_MT__And__No_Bold__And__Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dallas: ")])]), _c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Television Show")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America’s Team")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    staticClass: "C_Current__And__Bodoni_MT__And__Bold__And__No_Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4 Coping with History")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Groden and the Sixth Floor Museum at Dealey Plaza")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13  Commemoration or Return to the Cold War")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-9"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14  The Strange Case of Ernst Titovets (Oswald’s Russian Friend)")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15  Dallas: November 22, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16  Dallas: The Last Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/section0029#x_46289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0